import { useSessionStorage } from '../../../hooks';
import { useGetAllFieldsQuery } from '../../../store/api/customRequirements.api';
import { FC } from 'react';
import { getLocalStorageDistrictId } from '../../_core/utils';
import { DashboardPage } from './dashboard.page';
import { useGetDistrictQuery } from '../../../store/api/district.api';

export const DashboardDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');
	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();

	const { data: currentDistrict } = useGetDistrictQuery({ id: districtId }, { skip: !districtId });

	return (
		<DashboardPage
			isAdminRoute={false}
			currentDistrictId={districtId}
			currentDistrict={currentDistrict}
		/>
	);
};
